// src/components/modals/PlanSelectionModal.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/components/modals.css';
import useModalHistory from '../../hooks/useModalHistory';
const PlanSelectionModal = ({ isOpen, onClose, plans, onSelectPlan, selectedPlanId }) => {
  useModalHistory(isOpen, onClose, 'email-verification-modal');

  const [country, setCountry] = useState(null);
  const [locationLoading, setLocationLoading] = useState(true);

  // Hard-coded Rand prices (same as other modals)
  const randPrices = {
    1: 100,
    2: 370
  };

  useEffect(() => {
    const detectLocation = async () => {
      try {
        setLocationLoading(true);
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        setCountry(data.country_code);
      } catch (error) {
        console.error('Error detecting location:', error);
        setCountry('UNKNOWN');
      } finally {
        setLocationLoading(false);
      }
    };

    if (isOpen) {
      detectLocation();
    }
  }, [isOpen]);

  const getPriceDisplay = (plan) => {
    if (country === 'ZA') {
      return `R${randPrices[plan.id]?.toFixed(2) || '0.00'}/year`;
    } else {
      return `$${parseFloat(plan.Price).toFixed(2)}/year`;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content plan-modal">
        <div className="modal-header">
          <h5 className="modal-title">Choose Your Yearly Plan</h5>
          <button type="button" className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {locationLoading ? (
            <div className="text-center py-4">
              <p className="mt-2">Detecting location for pricing...</p>
            </div>
          ) : (
            <>
              <p className="subscription-notice">
                All plans are billed annually
                {country === 'ZA' && <span className="text-success"> • Pricing in South African Rand</span>}
                {country !== 'ZA' && country !== 'UNKNOWN' && <span className="text-primary"> • Pricing in US Dollars</span>}
              </p>
              <div className="plan-cards-grid">
                <div className="plan-cards-column">
                  {plans.filter((_, index) => index % 2 === 0).map((plan) => (
                    <div key={plan.id} className="plan-card">
                      <div className={`card-content ${plan.id === 2 ? 'premium-plan' : ''}`}>
                        {plan.id === 2 && <div className="popular-badge">Most Popular</div>}
                        <h5 className="card-title">{plan.Name}</h5>
                        <h6 className="card-subtitle">{getPriceDisplay(plan)}</h6>
                        <p className="card-description">{plan.Description}</p>
                        <ul className="feature-list">
                          <li>✓ {plan.Feature1}</li>
                          <li>✓ {plan.Feature2}</li>
                          <li>✓ {plan.Feature3}</li>
                        </ul>
                        <button
                          className={`select-plan-btn ${plan.id === selectedPlanId ? 'selected' : ''}`}
                          onClick={() => onSelectPlan(plan.id, plan.Name)}
                        >
                          {plan.Name === "Enterprise" ? "Contact Sales" : "Select Plan"}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="plan-cards-column">
                  {plans.filter((_, index) => index % 2 === 1).map((plan) => (
                    <div key={plan.id} className="plan-card">
                      <div className={`card-content ${plan.id === 2 ? 'premium-plan' : ''}`}>
                        {plan.id === 2 && <div className="popular-badge">Most Popular</div>}
                        <h5 className="card-title">{plan.Name}</h5>
                        <h6 className="card-subtitle">{getPriceDisplay(plan)}</h6>
                        <p className="card-description">{plan.Description}</p>
                        <ul className="feature-list">
                          <li>✓ {plan.Feature1}</li>
                          <li>✓ {plan.Feature2}</li>
                          <li>✓ {plan.Feature3}</li>
                        </ul>
                        <button
                          className={`select-plan-btn ${plan.id === selectedPlanId ? 'selected' : ''}`}
                          onClick={() => onSelectPlan(plan.id, plan.Name)}
                        >
                          {plan.Name === "Enterprise" ? "Contact Sales" : "Select Plan"}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="close-button-footer" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PlanSelectionModal;